import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import { Routes } from 'react-router-dom'
import mapRouterHelper from '../../../utils/MapRouterHelper'
import { DOCUMENT_SHORT_PREFIX_URL } from '../constants/config.document'
import DocumentCategoryRouters from '../modules/document-category/DocumentCategory.Routers'
import DocumentIncomingRouters from '../modules/document-incoming/DocumentIncoming.Routers'
import DocumentOutgoingRouters from '../modules/document-outgoing/DocumentOutgoing.Routers'

const DocumentRouters: AppRouterItem[] = [
  {
    path: `${DOCUMENT_SHORT_PREFIX_URL}/*`,
    element: (
      <Routes>
        {mapRouterHelper(DocumentCategoryRouters)}
        {mapRouterHelper(DocumentIncomingRouters)}
        {mapRouterHelper(DocumentOutgoingRouters)}
      </Routes>
    ),
  },
]

export default DocumentRouters
